<template>
  <div class="contact-content">

    <b-row class="py-3 m-0">

      <b-col lg="5">
        <b-row class="d-flex align-items-center mx-0">
            <h6 class="mx-1 mt-2 mb-0 text-secondary header d-flex align-items-center">Name</h6>
        </b-row>
        <b-input-group class="mt-2" size="sm">
            <b-input v-model="component.fullName" />
        </b-input-group>

        <!-- Phone Input Section -->
        <b-row class="d-flex align-items-center mx-0 mt-3">
            <h6 class="mx-1 mt-2 mb-0 text-secondary">{{ component.phone && component.phone.length > 1 ? 'Phone Numbers' : 'Phone Number' }}</h6>
            <b-button class="mt-2 ml-auto" size="sm" @click="addPhone" variant="link">add phone</b-button>
        </b-row>
        <b-input-group class="mt-2" size="sm" v-for="(phone, index) in component.phone" :key="index + 'phoneInput'">
          <!-- Dropdown for Phone Type -->
          <b-input-group-prepend>
            <b-dropdown class="phone-dropdown" toggle-class="text-decoration-none" dropright :id="'phoneTypeDropdown_' + index" v-model="phone.type" size="sm">
              <template #button-content>{{ phone.type ? phone.type : 'select type' }}</template>
              <b-dropdown-item @click="updatePhoneType(index, 'main')">main</b-dropdown-item>
              <b-dropdown-item @click="updatePhoneType(index, 'home')">home</b-dropdown-item>
              <b-dropdown-item @click="updatePhoneType(index, 'mobile')">mobile</b-dropdown-item>
              <b-dropdown-item @click="updatePhoneType(index, 'work')">work</b-dropdown-item>
              <b-dropdown-item @click="updatePhoneType(index, 'fax')">fax</b-dropdown-item>
              <b-dropdown-item @click="updatePhoneType(index, 'other')">other</b-dropdown-item>
            </b-dropdown>
          </b-input-group-prepend>
          <b-input v-model="phone.number" />
          <b-input-group-append>
            <b-button size="sm" @click="deletePhone(index)" variant="secondary"><b-icon-trash></b-icon-trash></b-button>
          </b-input-group-append>
        </b-input-group>
        <!-- Email Input Section -->
        <b-row class="d-flex align-items-center mx-0 mt-3">
            <h6 class="mx-1 mt-2 mb-0 text-secondary header">{{ component.email && component.email.length > 1 ? 'Email Addresses' : 'Email Address' }}</h6>        
            <b-button v-if="!component.email || (component.email && component.email.length === 0)" class="mt-2 ml-auto" size="sm" @click="addEmail" variant="link">add email</b-button>
        </b-row>
        <b-input-group class="mt-2" size="sm" v-for="(email, index) in component.email" :key="index + 'emailInput'">
          <b-input v-model="component.email[index]" :disabled="shouldDisableEmail(index)" />
          <b-input-group-append v-if="index !== 0">
            <b-button size="sm" @click="deleteEmail(index)" variant="secondary"><b-icon-trash></b-icon-trash></b-button>
          </b-input-group-append>
          <b-input-group-append>
            <b-button size="sm" @click="composeEmail(index)" variant="secondary"><b-icon-envelope></b-icon-envelope></b-button>
          </b-input-group-append>
        </b-input-group>
        </b-col>

        <b-col lg="5" class="ml-5">
        <!-- Address customer Section -->
        <b-row class="d-flex align-items-center mx-0">
            <h6 class="mx-1 mt-2 mb-0 text-secondary">{{ component.address && component.address.length > 1 ? 'Mailing Addresses' : 'Mailing Address' }}</h6>
            <b-button class="mt-2 ml-auto" size="sm" @click="addAddress" variant="link">Add Address</b-button>
        </b-row>
        <b-row class="mt-2" v-for="(address, index) in component.address" :key="index">
          <b-col>
            <customer-address :fullName='component.fullName' :address='address' @input="updateAddress(index, $event)"></customer-address>
            <div class="d-flex justify-content-end mb-5">
            <b-button class="mt-2" size="sm" @click="deleteAddress(index)" variant="secondary">Delete Address</b-button>
            </div>
          </b-col>
        </b-row>
      </b-col>
    

    </b-row>
        <!-- Save Button Section -->
    <div class="bottomBar">
            <b-button v-if="hasChanges" class="mx-4" size="sm" :variant="hasChanges ? 'dark' : 'secondary'"  @click="discardChanges">
                Discard Changes
            </b-button>
            <b-button class="saveButton" size="sm" :variant="saveButtonVariant" @click="saveChanges"><span v-if="isSaving"><b-spinner small /></span><span v-else>{{recentlySaved ? 'Saved!' : 'Save Changes'}}</span></b-button>
        </div>
  </div>
</template>

<script>
  import CustomerAddress from "./CustomerAddress";
  import AddressMixin from "../../builders/address";
  import objectMixin from "../../mixins/object";
  import customerApi from '../../api/customers';

  export default {
      name: "CustomerContact",
      props: [ "customer" ],
      components: { CustomerAddress },
      mixins: [ AddressMixin, objectMixin, customerApi ],
      data() {
          return {
              hasChanges: false,
              recentlySaved: false,
              isSaving: false,
              originalCustomer: null,
              options: [{ value: null, text: 'Search by...', disabled: true},
                { value: 'query', text: 'Name / Email / ID' },
                { value: 'platformId', text: 'Platform ID' },
                { value: 'orderId', text: 'Order ID'},
                { value: 'address', text: 'Address' },
                { value: 'phoneNumber', text: 'Phone'},
              ],
              component: {
              // Initialize phone and email as empty arrays
              phone: [],
              email: [],
              address: [],
            },
            }
      },
      watch: {
        'component': {
          handler: 'checkChanges',
          deep: true,
        },
        'hasChanges': {
          handler: 'handleChanges', // Corrected the handler function
          deep: true, // Added the 'deep' option
        },
      },
      created() {
        if (Object.keys(this.customer).length === 0) {
          // If the customer is an empty object, set default values for the component
          this.$set(this.component, 'fullName', '');
          this.$set(this.component, 'phone', []);
          this.$set(this.component, 'email', []);
          this.$set(this.component, 'address', []);
        } else {
          // If the customer is not an empty object, clone the customer data
          this.originalCustomer = this.deepClone(this.customer);
          this.clone(this.customer);
        }
      },
      computed: {
        saveButtonVariant() {
            if (this.recentlySaved) {
                return 'primary';
            } else if (this.hasChanges) {
                return 'success';
            } else {
                return 'secondary';
            }
        },
      },
      methods: {
        addPhone() {
          if (!this.component.phone) {
            this.component.phone = []
          }
          this.component.phone.push({ number: '' });
        },
        addEmail() {
          if (!this.component.email) {
            this.component.email = []
          }
          this.component.email.push('');
        },
        addAddress() {
          this.component.address.push({});
        },
        deletePhone(index) {
        this.component.phone.splice(index, 1);
        },
        deleteEmail(index) {
          console.log(index);
          if (index !== 0) {
            this.component.email.splice(index, 1);
          } 
        },
        deleteAddress(index) {
          this.component.address.splice(index, 1);
        },
        updatePhoneType(index, type) {
          this.$set(this.component.phone[index], 'type', type);
        },
        updateAddress(index, updatedAddress) {
          this.$set(this.component.address, index, updatedAddress);
        },
        async saveChanges() {
        this.isSaving = true;

        try {
          if (this.customer && this.customer.customerId) {
              // Update existing customer
              const updatedCustomer = await this.updateCustomer(
                this.customer.customerId,
                this.component
              );
              this.$emit("setCustomer", updatedCustomer.data);
              this.$set(this, "originalCustomer", this.deepClone(updatedCustomer.data));
              this.$set(this, "component", this.deepClone(updatedCustomer.data));
            } else {
              // Create a new customer
              const newCustomer = await this.createCustomer({fullName: this.component.fullName});
              const updatedCustomer =  await this.updateCustomer(
                newCustomer.customerId,
                this.component
              );
              this.$emit("setCustomer", updatedCustomer.data);
              this.$set(this, "originalCustomer", this.deepClone(updatedCustomer.data));
              this.$set(this, "component", this.deepClone(updatedCustomer.data));
            }
          } finally {
            this.recentlySaved = true;
            setTimeout(() => {
              this.recentlySaved = false;
            }, 2000);
            this.isSaving = false; // Reset the isSaving flag after saving
          }
        },
        handleChanges(newVal) {
          this.$emit("handleChanges", newVal);
        },
        discardChanges() {
          this.$set(this, 'component', this.deepClone(this.originalCustomer));
          this.hasChanges = false;
        },  
        checkChanges() {
          this.hasChanges = !this.isEqual(this.component, this.originalCustomer) && this.component.fullName.length > 0;
        },
        shouldDisableEmail(index) {
          return this.originalCustomer && this.originalCustomer.email && index < this.originalCustomer.email.length;
        },
        composeEmail(index) {
          const email = this.component.email[index];
          if (email) {
              window.location.href = `mailto:${email}`;
          }
        },
        
      },

  }
</script>

<style scoped>
  .header {
    height: 31px;
    display: flex;
    align-items: center;
  }
  .shipInputs {
      width: 50%;
  }

  .contact-content {
    max-height: calc(100vh - 200px);
    overflow-y: auto;
  }

  .bottomBar {
    z-index: 100;
    position: fixed;
    bottom: 0;
    right: 0;
    left: 0;
    width: 100%;
    height: 60px;
    background-color: rgba(173, 171, 171, 0.291);
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 0 40px;
  }
</style>